import React from 'react'
import { any, async, fromJSX, StandardLocalWidget } from 'widgets-for-react'
import { Loader } from '../../../Shared/Frontend/components/loader'
import { Pageheader } from '../../../Shared/Frontend/components/pageheader'
import { AboutUsLayout } from './aboutUs.layout'
import { AboutUsState, aboutUsUpdaters } from './aboutUs.state'

export const aboutUsWidget: StandardLocalWidget<AboutUsState> = (currentState) =>
  any([
    async(currentState.teamMembers).map(aboutUsUpdaters.teamMembers),
    any([
      fromJSX(() => (
        <Pageheader
          title="Your partner for technology, design and strategy"
          introduction="As digital partner, we help you with all facets of digital transformation. We are a digital agency and IT partner with smart, creative and high-quality solutions. We are keen to show you what we do best!"
        />
      )),
      fromJSX(() =>
        currentState.teamMembers.kind === 'loaded' ? (
          <AboutUsLayout.TeamMembersCards teamMembers={currentState.teamMembers.value} />
        ) : (
          <Loader />
        )
      ),
    ]),
  ])
